module.exports = __webpack_public_path__ + "img/pic_2.039f44c3.jpg";